import { ApplicantStatus } from "shared/types";
import { cx } from "shared/utils";

export const VerificationProgress = ({
  totalVerifications = 0,
  completedVerifications = 0,
  status,
  className
}: {
  totalVerifications: number;
  completedVerifications: number;
  status: ApplicantStatus;
  className?: string;
}) => {
  const getProgressWidth = () => {
    if (status === ApplicantStatus.Submitted) return "100%";

    if (status === ApplicantStatus.Finished) return "95%";

    if (totalVerifications > 0)
      return `${Math.max(
        0,
        Math.min(100, (completedVerifications / totalVerifications) * 100)
      )}%`;

    return "0%";
  };

  return (
    <div
      className={cx(
        className,
        "h-2 rounded w-full",
        status === ApplicantStatus.Submitted ? "bg-success-50" : "bg-primary-20"
      )}
    >
      <div
        className={cx(
          "h-2 rounded",
          status === ApplicantStatus.Submitted
            ? "bg-success-500"
            : "bg-primary-500"
        )}
        style={{
          width: getProgressWidth()
        }}
      />
    </div>
  );
};
